"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useManualReadingLegacyMutation = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var core_1 = require("../../../core");
var use_manual_readings_query_1 = require("./use-manual-readings-query");
function useManualReadingLegacyMutation(_a, onSuccess, onError) {
    var accountId = _a.accountId, msn = _a.msn, mpxn = _a.mpxn, fuel = _a.fuel, meterType = _a.meterType, _b = _a.force, force = _b === void 0 ? false : _b;
    var invalidateCache = (0, use_manual_readings_query_1.useInvalidateManualReadingsLegacyQuery)(accountId, msn, mpxn, fuel);
    var api = core_1.configService.getConfig().api;
    var queryString = new URLSearchParams({
        force: force ? 'true' : 'false',
    }).toString();
    var manualReadingsEndpoint = "".concat(api.baseUrl, "/rlc/rac-public-api/api/v5/supplypoints/").concat(fuel, "/").concat(mpxn, "/meters/").concat(msn, "/readings?").concat(queryString);
    return (0, ui_tools_1.useReactMutation)(function (data) {
        var body = __assign(__assign({}, data), { readingDateTime: data.readingDateTime
                ? (0, date_fns_1.format)(data.readingDateTime, "yyyy-MM-dd'T'HH:mm:ss")
                : (0, date_fns_1.format)((0, date_fns_1.startOfToday)(), "yyyy-MM-dd'T'HH:mm:ss"), readingType: 'CustomerSubmittedReading', meterType: meterType });
        return core_1.apiService.post({
            url: manualReadingsEndpoint,
            body: body,
            headers: {
                'zone-id': 'Europe/London', // TODO: This will need some timezone multi-brand solution in future
            },
        });
    }, {
        onSuccess: function () {
            invalidateCache();
            if (onSuccess) {
                onSuccess();
            }
        },
        onError: function (error) {
            if (onError) {
                onError(error);
            }
        },
    });
}
exports.useManualReadingLegacyMutation = useManualReadingLegacyMutation;
